import React, { FormEvent, useState } from 'react';
import { Layout, Input, Button, Icon } from '@oscar/theme';
import { TextField } from 'common/components';
import { ActionField, Field, useFormContext } from '@oscar/form';
import FormList from 'common/components/FormList';
import { SearchResult } from './SearchResult';
import { StatusInstance } from 'views/pages/create-instrulation/hooks/useStatus';
import { SAP_STATUS_LIST } from 'common/constants/insulation';
import { set } from 'lodash';
import { useDeepCompareEffect } from '@oscar/utils';
import '../style.scss';

export interface PTWNotification {
  id: string;
  ePTWId: string;
  status: number | null;
  jobDescription: string | null;
  startDate: string | any | null;
  endDate: string | any | null;
  isLocal: boolean;
}

const isReadOnly = (statusRequest?: StatusInstance) => {
  return statusRequest?.state === 'VIEW';
};
const SearchContent = (props: any) => {
  const { setItem, readOnly, valueSearchRequest, setValueSearchRequest } =
    props;
  const [formContext] = useFormContext();
  const idRes = formContext.selectors?.getInitalValue()?.ePTWNo;

  // Auto-load existing PTW IDs when component mounts - now using default values only
  useDeepCompareEffect(() => {
    if (idRes?.ePTWNoReinstatement || idRes?.ePTWNoRemoval) {
      [
        ...(idRes?.ePTWNoRemoval || []),
        ...(idRes?.ePTWNoReinstatement || []),
      ]?.forEach(
        (id: any, indx: any) => id && loadExistingPTWWithDefaults(id, indx),
      );
    }
  }, [idRes?.ePTWNoReinstatement, idRes?.ePTWNoRemoval]);

  // Helper function to update form values with PTW data
  const setValuePTW = (result?: any, index?: any) => {
    const form = formContext.form?.getFieldsValue();
    formContext.form?.setFieldsValue(
      set(form, `listPTWDetail[${index}]`, result),
    );
  };

  // Function to load existing PTW with default values only (no API call)
  const loadExistingPTWWithDefaults = (ptwId: string, index: number) => {
    const defaultResult = {
      ePTWId: ptwId,
      status: null,
      jobDescription: null,
      startDate: null,
      endDate: null,
      isLocal: true, // Mark as local/default
    };
    setValuePTW(defaultResult, index);
  };

  const handleAddPTW = () => {
    if (valueSearchRequest && valueSearchRequest.trim().length > 0) {
      const ptwId = valueSearchRequest.trim();
      // Add PTW with default values only (no API call)
      setItem?.({
        ePTWId: ptwId,
        status: null,
        jobDescription: null,
        startDate: null,
        endDate: null,
        isLocal: true,
      });
      // Clear the input after adding
      setValueSearchRequest('');
    }
  };

  if (readOnly) return null;
  return (
    <Layout.Content>
      <div className="search-container">
        <div className="description">Enter PTW number to add to your list</div>
        <Input
          prefix={
            <Button type="link" size="small" onClick={handleAddPTW}>
              <Icon icon="plus" />
            </Button>
          }
          placeholder="Enter PTW No (max 10 characters)"
          size={'large'}
          maxLength={10}
          value={valueSearchRequest}
          onChange={(event: FormEvent<HTMLInputElement>) => {
            const value = event.currentTarget.value;
            if (/^[a-zA-Z0-9\-_]*$/.test(value)) {
              setValueSearchRequest(value);
            }
          }}
          onPressEnter={handleAddPTW}
        />
      </div>
    </Layout.Content>
  );
};

const PTWNotificationItem = (item: PTWNotification) => {
  return <TextField label={item.ePTWId} value="" primary />;
};

const CreateButton = () => (
  <Button
    className="create-button"
    type="secondary"
    size="middle"
    onClick={() => {
      const url = 'https://eptw.petronas.com/';
      window.open(url, 'eptw', 'noopener');
    }}
    style={{ marginBottom: '10px' }}
    disabled={true}
    hidden={true}
  >
    CREATE NEW
  </Button>
);

interface Props {
  statusRequest?: StatusInstance;
}

export default ({ statusRequest }: Props) => {
  return (
    <div className="scaffold-detail">
      <FormList<PTWNotification>
        keyField="ePTWId"
        title="ePTW ID"
        name="listPTWDetail"
        headerComponent={SearchContent}
        detailComponent={SearchResult}
        onItemRenderer={PTWNotificationItem}
        createButtonComponent={CreateButton}
        readOnly={isReadOnly(statusRequest)}
      />
    </div>
  );
};
